export default "__VITE_ASSET__95bb5be8__"